/**
 * Sanitize a name so that it only contains valid characters.
 */
export function sanitizeName(s: string): string {
  return s.replace(/\W+/g, '-').replace(/(-)\1/g, '-');
}

export function sanitizeNameLowercase(s: string): string {
  return sanitizeName(s.toLowerCase());
}
